import React from 'react';
import { Card } from '../ui/card';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, PieChart, Pie, Cell } from 'recharts';
import { CHART_TOOLTIP_STYLE } from './adminConstants';

export const AdminChartsTab = ({ activityData, pieData }) => (
  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.5rem' }}>
    <Card style={{ background: '#fff', border: '1px solid #ECE7DE', borderRadius: 14, padding: '1.5rem' }}>
      <h3 style={{ fontFamily: 'Cabinet Grotesk', fontSize: '1rem', fontWeight: 600, marginBottom: '1.25rem', color: '#0076A3' }}>Platform Activity</h3>
      <ResponsiveContainer width="100%" height={220}>
        <BarChart data={activityData}>
          <CartesianGrid strokeDasharray="3 3" stroke="#F0EBE3" />
          <XAxis dataKey="name" tick={{ fill: '#94A3B8', fontSize: 11 }} />
          <YAxis tick={{ fill: '#94A3B8', fontSize: 11 }} allowDecimals={false} />
          <Tooltip contentStyle={CHART_TOOLTIP_STYLE} />
          <Bar dataKey="value" fill="#0076A3" radius={[4, 4, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </Card>
    <Card style={{ background: '#fff', border: '1px solid #ECE7DE', borderRadius: 14, padding: '1.5rem' }}>
      <h3 style={{ fontFamily: 'Cabinet Grotesk', fontSize: '1rem', fontWeight: 600, marginBottom: '1.25rem', color: '#0076A3' }}>User Distribution</h3>
      <div style={{ display: 'flex', alignItems: 'center', gap: '2rem' }}>
        <ResponsiveContainer width="50%" height={180}>
          <PieChart>
            <Pie data={pieData} cx="50%" cy="50%" innerRadius={45} outerRadius={70} dataKey="value" strokeWidth={0}>
              {pieData.map((entry) => <Cell key={`pie-${entry.name}`} fill={entry.color} />)}
            </Pie>
            <Tooltip contentStyle={CHART_TOOLTIP_STYLE} />
          </PieChart>
        </ResponsiveContainer>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
          {pieData.map(d => (
            <div key={d.name} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.8125rem' }}>
              <span style={{ width: 10, height: 10, borderRadius: '50%', background: d.color }} />
              <span style={{ color: '#64748B' }}>{d.name}: {d.value}</span>
            </div>
          ))}
        </div>
      </div>
    </Card>
  </div>
);
